import { createAsyncThunk } from '@reduxjs/toolkit'

import { ITransactionData } from 'meta/pages/v4/transaction'
import { TransactionController } from 'controller/transaction'

type Returned = ITransactionData

type Props = {
  transactionCode: string
}

export const getData = createAsyncThunk<Returned, Props>('pages/transaction/data', async (props) => {
  const { transactionCode } = props

  return TransactionController.getData({ transactionCode })
})
